import axios from "axios";

export const state = {
    patienttestresults: [],
};

export const getters = {
    patienttestresults: state => state.patienttestresults,
};

export const mutations = {
    setPatients(state, newValue) {
        state.patienttestresults = newValue
    },
};

export const actions = {
    fetchPatientTestresults({ commit }) {
        axios.get('/patienttestresults').then(res => {
            commit('setPatients', res.data.visits)
        })
    },
    filterPatientTestResults({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterpatienttestresults";
        axios.post(url, formData).then((response) => {
            commit('setPatients', response.data.visits)
        })
    },
};
